import { errorStates } from "@hz/common/constants";

import { AlertTriangle } from "lucide-react";

import { Group, Heading, HStack, Link, Text } from "@chakra-ui/react";

import { Button } from "@components/ui/button";

import BookCallButton from "./components/book-call-button";
import ErrorInfoBox from "./components/error-info-box";
import type { ErrorScreenProps } from "./types";

const UNKNOWN_SCREEN = ({ type, errorDetails, eventId, email, onRetry }: ErrorScreenProps) => {
  const mailToLink = `mailto:${email}?subject=Error%20Report&body=${encodeURIComponent(
    `Hi Stackfully team,\n\nA ${errorStates.NO_PERMISSION} occurred with the following details:\n\n${errorDetails}\n\nThank you.`,
  )}`;

  return (
    <Group flexDirection="column">
      <AlertTriangle
        size={48}
        className="text-red-500"
      />
      <Heading size="xl">{"Oops! Something Went Wrong"}</Heading>
      <Text color="gray.600">
        An unexpected error occurred. Please try again or contact{" "}
        <Link
          href={mailToLink}
          color="blue.500"
          textDecoration="none"
        >
          {email}
        </Link>{" "}
        with the details below:
      </Text>

      <ErrorInfoBox
        type={type}
        errorDetails={errorDetails}
        eventId={eventId}
      />

      <HStack>
        <Button
          colorPalette="blue"
          size="lg"
          onClick={onRetry}
          mt="4px"
        >
          Retry
        </Button>

        <BookCallButton variant="outline" />
      </HStack>
    </Group>
  );
};

export default UNKNOWN_SCREEN;
